import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BatteryBuilderPage from "./pages/BatteryBuilderPage";
import EmbedPage from "./pages/EmbedPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BatteryBuilderPage />} />
        <Route path="/embed" element={<EmbedPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
